/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const AngleRightLarge: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M4.29289 14.2929C3.90237 14.6834 3.90237 15.3166 4.29289 15.7071C4.68342 16.0976 5.31658 16.0976 5.70711 15.7071L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289L5.70711 0.292893C5.31658 -0.0976315 4.68342 -0.0976315 4.29289 0.292893C3.90237 0.683417 3.90237 1.31658 4.29289 1.70711L10.5858 8L4.29289 14.2929Z' />
		</Svg>
	);
};

export { AngleRightLarge };
